'use client';

import { motion, HTMLMotionProps } from 'motion/react';
import { FC } from 'react';

interface MotionWrapperProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
}
/**
 * A wrapper component that enables the use of Framer Motion's `motion.div` in server components.
 * Regular `motion.div` cannot be used in server components because it requires client-side rendering.
 * This wrapper allows you to integrate animations while following server-side rendering rules.
 */
export const MotionWrapper: FC<MotionWrapperProps> = ({ children, ...props }) => (
  <motion.div {...props}>{children}</motion.div>
);
